import { Component } from "react";
import View from "./view";
import "./index.css";

class Overlay extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return View.call(this);
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/overlay/index.js